import type { SxStyle } from '@aibees/shared/theme';
import { cardBase } from '../testimonial-card-shared';

export const root: SxStyle = {
  ...cardBase,
  p: 1.5,
};
